import { mapGetters } from 'vuex';

export default {
  props    : ['content', 'title', 'date', 'academicMainId', 'academicMainTypeId'],
  computed : {
    ...mapGetters({
      getterUserContext       : 'plataforma/content/getterUserContext',
      getterEnrollmentContext : 'plataforma/enrollment/getterEnrollmentContext',
      getterMenuContext       : 'plataforma/content/getterMenuContext'
    })
  }
};
